import { fork } from 'redux-saga/effects';

import generalSagas from './general';

export default function* dealerConfigSagas() {
  yield fork(generalSagas);
}
